import { MapPin } from "lucide-react";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";
import { useDistanceUnits } from "@/hooks/useDistanceUnits";

interface LocationAndZoneFiltersProps {
  locationFilter: string;
  onLocationFilterChange: (value: string) => void;
  className?: string;
}

export const LocationAndZoneFilters = ({ 
  locationFilter, 
  onLocationFilterChange,
  className
}: LocationAndZoneFiltersProps) => {
  const { distanceOptions } = useDistanceUnits();
  
  return (
    <Card className={`border-none h-full ${className || ''}`} style={{ backgroundColor: '#e0F2Eb' }}>
      <CardContent className="p-2 h-full flex flex-col justify-center">
        <div className="space-y-2">
          <div className="flex items-center space-x-2">
            <MapPin className="h-4 w-4 flex-shrink-0" style={{ color: '#30565c' }} />
            <span className="font-medium text-xs" style={{ color: '#30565c' }}>Location</span>
          </div>
          <RadioGroup
            value={locationFilter}
            onValueChange={onLocationFilterChange}
            className="grid grid-cols-2 gap-2"
          >
            <div className="flex items-center space-x-1">
              <RadioGroupItem value="all" id="all-locations" />
              <Label htmlFor="all-locations" className="text-xs cursor-pointer" style={{ color: '#30565c' }}>All</Label>
            </div>
            {distanceOptions.map((option) => (
              <div key={option.value} className="flex items-center space-x-1">
                <RadioGroupItem value={option.value} id={option.value} />
                <Label htmlFor={option.value} className="text-xs cursor-pointer leading-tight" style={{ color: '#30565c' }}>
                  {option.label}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </CardContent>
    </Card>
  );
};
